import { FEATURE_FLAGS } from 'src/constants/featureFlags'
import getEnv, { ENV_VARIABLES } from 'src/config'
import { posthog } from 'posthog-js'
import { useState } from 'react'

type FeatureFlagKeys = keyof typeof FEATURE_FLAGS
type FeatureFlagValues = (typeof FEATURE_FLAGS)[FeatureFlagKeys]

// On prod it takes value from posthog. On localhost and staging it takes value from localStorage because w don't have "Multiple variant" (A/B/C) feature flags on Staging Posthog
export const useFeatureFlag = (flagName: FeatureFlagValues) => {
  const isDevOrStaging = getEnv(ENV_VARIABLES.ENV) !== 'production'
  const [initialized, setInitialized] = useState(isDevOrStaging ? true : false)

  if (!isDevOrStaging) {
    posthog.onFeatureFlags(() => {
      if (!initialized) {
        setInitialized(true)
      }
    })
  }

  let value: string | boolean | undefined | null = undefined
  if (isDevOrStaging) {
    value = window.localStorage.getItem(flagName)
  } else {
    value = initialized ? posthog.getFeatureFlag(flagName) : undefined
  }

  return { value, initialized }
}
